import { SignupPayload, assignRef, validateSignup, verifySportEmail } from "./Login";
import firebaseAnimeParliament, { auth, db, assignAnimeParliament } from "firebaseAnimeParliament"

import { Callback } from "./utils";
import { User, createUserWithEmailAndPassword, sendEmailVerification } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { getReferUser, saveUserData, saveUsername } from "../../Contexts/User";

import axios from "axios";
import { generateUsername } from "common/utils/strings";

import { useContext } from "react";
import animeParliament from "firebaseAnimeParliament";

export const SignupRegularForAnimeParliament = async (
    payload: SignupPayload,
    callback: Callback<User>,
    userData?: { [key: string]: any },
    parentEmailId?: any
) => {
    try {

        validateSignup(payload);
        const auth = animeParliament.auth();
        const userCredential = await auth.createUserWithEmailAndPassword(
            payload.email,
            payload.password
        );
        if (auth?.currentUser) {
            console.log('anime', auth?.currentUser);
            // await sendEmailVerification(auth?.currentUser);
            const referUser = await getReferUser(animeParliament.firestore(), parentEmailId);
            console.log(referUser, "referUserdata")
            await saveUserData((auth?.currentUser?.uid || ''), db, {
                displayName: await generateUsername(),
                ...userData,
                firstTimeLogin: false,
                isVoteToEarn: true,
                parent: referUser?.uid,
                uid: auth?.currentUser?.uid
            });
            // await assignSport({ parent: referUser?.uid, child: auth?.currentUser?.uid })
            await assignRef(referUser?.uid, auth?.currentUser?.uid, process.env.REACT_APP_SPORT_API || '')
            await verifySportEmail(auth?.currentUser?.uid, (auth?.currentUser?.email || ''), (process.env.REACT_APP_SPORT_API || ''));
            // const userRef = doc(db, "users", auth?.currentUser?.uid);
            // await setDoc(userRef, { firstTimeLogin: true, ...userData }, { merge: true });
        } else {
            console.log('anime', auth);
        }
        //@ts-ignore
        // callback.successFunc(userCredential.user);
        return true;
    } catch (e) {
        // @ts-ignore
        console.log('anime error', e.code);
        // @ts-ignore
        if (e?.code) {
            // @ts-ignore
            const matches = e.code.replace("auth/", "");
            const lastmatches = matches.replace(/\b(?:-)\b/gi, " ");
            // callback.errorFunc({ message: '' /* lastmatches */ } as Error);
        }
        return false;
    }
};
